import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import IconButton from "@mui/material/IconButton";
import { Alert, Box, Button, Container, Typography } from "@mui/material";
import LogoIcon from "../logo/LogoIcon";
import LinedBox from "../partials/LinedBox";
import CheckIcon from "@mui/icons-material/Check";
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import { useRouter } from "next/router";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AlertDialog from "../../components/register/Modal";


const SVG = ({ active, completed, index }) => {
  return (
    <Box
      bgcolor={
        active ? "primary.light" : completed ? "success.light" : "grey.border30"
      }
      borderRadius="4px"
      justifyContent={"center"}
      alignItems={"center"}
      display="flex"
      color={active ? "white" : completed ? "success.dark" : "grey.light"}
    >
      {active ? (
        <Typography
          variant="small"
          color={"primary.dark"}
          px="0.6em"
          fontWeight={600}
        >
          {index + 1}
        </Typography>
      ) : completed ? (
        <CheckIcon fontSize="14px" />
      ) : (
        <Typography
          variant="small"
          color={"grey.light"}
          px="0.6em"
          fontWeight={600}
        >
          {index + 1}
        </Typography>
      )}
    </Box>
  );
};


const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.primary.main,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

const RegisterModal = ({ show, handleShowChange, closeModal }) => {
  const [showAlert, setShowAlert] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const [checked, setChecked] = useState(false)

  const handleClose = () => {
    closeModal();
  };

  const continueReg = () => {
    // handleShowChange();
    setShowAlert(true);
  };

  const router = useRouter()

  return (
    <>
      <Dialog
        open={show}
        fullScreen
        fullWidth
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          zIndex: "10005",
          "& .MuiDialog-paper": {
            px: { md: "1.2em", xs: '0.8em' },
            py: "1em",
            borderRadius: "8px",
            minHeight: "27rem",
          },
          backgroundColor: "#F5F6F7",
        }}
      >
        <DialogContent sx={{ background: "#F5F6F7", paddingX: { xs: '0px', md: '20px' } }}>
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              fontSize: "18px",
              fontWeight: 500,
              color: "grey.dark",
              marginBottom: "1em",
              justifyContent: "flex-end",
              display: "flex",
              "& svg": {
                padding: "0",
              },

            }}
          >
            <IconButton
              aria-label="close"
              size="large"
              sx={{ fontSize: "1.4rem" }}
              onClick={handleClose}
            >
              <ClearRoundedIcon fontSize="inherit" />
            </IconButton>
          </DialogTitle>
          <Box sx={{ width: "100%", paddingBottom: "4em" }}>
            <Container
              sx={{
                mx: "auto",
                display: "flex",
                justifyContent: "center",
                py: "0.5em",
                position: "relative",
                alignItems: "center",
                flexDirection: "column",
                px: { xs: '0px', md: '16px' }
              }}
            >
              <LogoIcon />
              <Stack direction="row" spacing={1} alignItems="center" my='1em'>
                {/* <Typography variant="big">
                  Charity
                </Typography> */}
                {/* <AntSwitch checked={true} inputProps={{ 'aria-label': 'ant design' }} /> */}
                {/* <AntSwitch checked={checked} onChange={handleChange} inputProps={{ 'aria-label': 'ant design' }} /> */}
                {/* <Typography variant="big">Individual</Typography> */}
              </Stack>
              {
                !checked ? <Box
                  sx={{
                    paddingX: {
                      xs: "1em",
                      sm: "4em",
                      md: "4em",
                    },
                  }}
                  bgcolor={"white"}
                  maxWidth={"30rem"}
                  width={"90%"}
                  paddingY="2em"
                  borderRadius={"16px"}
                  mt='2em'
                >
                  <Alert
                    severity="error"
                    color={"grey"}
                    sx={{ marginBlock: "1em", borderRadius: "8px", fontSize: "14px", background: '#fafafa', color: '#425A70' }}
                  >
                    Listed below are the required documents, and necessary informarion required to complete the registration and onboarding process on the platform
                  </Alert>
                  <Box
                    alignItems={"flex-start"}
                    display="flex"
                    columnGap={"10px"}
                    mb="1em"
                  >
                    <Box
                      bgcolor={"success.light"}
                      borderRadius="4px"
                      justifyContent={"center"}
                      alignItems={"center"}
                      display="flex"
                      color={"success.dark"}
                      flexGrow={0}
                    >
                      <Typography
                        variant="small"
                        color={"success.dark"}
                        px="0.6em"
                        fontWeight={600}
                      >
                        1
                      </Typography>
                    </Box>
                    <Typography variant="big" component={"span"}>
                      Choose a primary account holder (Super user), who must be
                      authorized to manage the charity’s iDonatio account.
                    </Typography>
                  </Box>
                  <Box
                    alignItems={"flex-start"}
                    display="flex"
                    columnGap={"10px"}
                    mb="1em"
                  >
                    <Box
                      bgcolor={"success.light"}
                      borderRadius="4px"
                      justifyContent={"center"}
                      alignItems={"center"}
                      display="flex"
                      color={"success.dark"}
                      flexGrow={0}
                    >
                      <Typography
                        variant="small"
                        color={"success.dark"}
                        px="0.6em"
                        fontWeight={600}
                      >
                        2
                      </Typography>
                    </Box>
                    <Typography variant="big" component={"span"}>
                      The primary account holder should complete the registration
                      and the confirmation process outlined below.
                    </Typography>
                  </Box>
                  <Box
                    alignItems={"flex-start"}
                    display="flex"
                    columnGap={"10px"}
                    mb="1em"
                  >
                    <Box
                      bgcolor={"success.light"}
                      borderRadius="4px"
                      justifyContent={"center"}
                      alignItems={"center"}
                      display="flex"
                      color={"success.dark"}
                      flexGrow={0}
                    >
                      <Typography
                        variant="small"
                        color={"success.dark"}
                        px="0.6em"
                        fontWeight={600}
                      >
                        3
                      </Typography>
                    </Box>
                    <Typography variant="big" component={"span"}>
                      Once the account is set up, additional users who may each
                      have different levels of access depending on their role may
                      be added. One of these must be another super user.
                    </Typography>
                  </Box>
                  <Box
                    alignItems={"flex-start"}
                    display="flex"
                    columnGap={"10px"}
                    mb="1em"
                  >
                    <Box
                      bgcolor={"success.light"}
                      borderRadius="4px"
                      justifyContent={"center"}
                      alignItems={"center"}
                      display="flex"
                      color={"success.dark"}
                      flexGrow={0}
                    >
                      <Typography
                        variant="small"
                        color={"success.dark"}
                        px="0.6em"
                        fontWeight={600}
                      >
                        4
                      </Typography>
                    </Box>
                    <Typography variant="big" component={"span"}>
                      You will need the following to complete your registration
                      and confirmation process:
                    </Typography>
                  </Box>
                  <LinedBox>
                    <Box
                      alignItems={"flex-start"}
                      display="flex"
                      columnGap={"10px"}
                      mb="1em"
                    >
                      <Box
                        bgcolor={"primary.light"}
                        borderRadius="4px"
                        justifyContent={"center"}
                        alignItems={"center"}
                        display="flex"
                        color={"success.dark"}
                        flexGrow={0}
                      >
                        <CheckIcon fontSize="14px" />
                      </Box>
                      <Typography variant="big" component={"span"}>
                        Charity’s details: <br /> i. Registered name <br /> ii.
                        Charity Commission number and Company registration number
                        if you have one. <br /> iii. Registered address <br /> iv.
                        Phone number <br /> v. Email address <br /> vi. Website
                        URL <br /> vii. Date charity was established
                      </Typography>
                    </Box>
                    <Box
                      alignItems={"flex-start"}
                      display="flex"
                      columnGap={"10px"}
                      mb="1em"
                    >
                      <Box
                        bgcolor={"primary.light"}
                        borderRadius="4px"
                        justifyContent={"center"}
                        alignItems={"center"}
                        display="flex"
                        color={"success.dark"}
                        flexGrow={0}
                      >
                        <CheckIcon fontSize="14px" />
                      </Box>
                      <Typography variant="big" component={"span"}>
                        Charity’s bank account <br />
                        i. Account number <br /> ii. Sort code
                      </Typography>
                    </Box>
                    <Box
                      alignItems={"flex-start"}
                      display="flex"
                      columnGap={"10px"}
                      mb="1em"
                    >
                      <Box
                        bgcolor={"primary.light"}
                        borderRadius="4px"
                        justifyContent={"center"}
                        alignItems={"center"}
                        display="flex"
                        color={"success.dark"}
                        flexGrow={0}
                      >
                        <CheckIcon fontSize="14px" />
                      </Box>
                      <Typography variant="big" component={"span"}>
                        Primary account holder’s details <br />
                        i. Name
                        of primary account holder <br /> ii. Email address (Used as their
                        primary login.) <br />iii. Job title <br />  iv. Date of birth  <br />  v. Home address <br /> <span style={{ color: 'red' }}> vi. Two verification documents: proof of identity and address</span>
                      </Typography>
                    </Box>
                    <Box
                      alignItems={"flex-start"}
                      display="flex"
                      columnGap={"10px"}
                      mb="1em"
                    >
                      <Box
                        bgcolor={"primary.light"}
                        borderRadius="4px"
                        justifyContent={"center"}
                        alignItems={"center"}
                        display="flex"
                        color={"success.dark"}
                        flexGrow={0}
                      >
                        <CheckIcon fontSize="14px" />
                      </Box>
                      <Typography variant="big" component={"span"}>
                        Authorization letter on Charity letterhead  <br />
                        i. You will need to
                        upload a letter of authorization on your charity letterhead.
                      </Typography>
                    </Box>
                    <Box
                      alignItems={"flex-start"}
                      display="flex"
                      columnGap={"10px"}
                      mb="1em"
                    >
                      <Box
                        bgcolor={"primary.light"}
                        borderRadius="4px"
                        justifyContent={"center"}
                        alignItems={"center"}
                        display="flex"
                        color={"success.dark"}
                        flexGrow={0}
                      >
                        <CheckIcon fontSize="14px" />
                      </Box>
                      <Typography variant="big" component={"span"}>
                        Proof of charity registration and identity <br />
                        i. This should be
                        your registration certificate from the Charity Commission or/and
                        HMRC. You must be a registered charity to use our platform.
                        <br />
                        ii.
                        Any document with the charity’s name and address (bank statement
                        or utility bill. Not mobile or telephone bill)
                      </Typography>
                    </Box>
                  </LinedBox>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent:
                        "space-between"
                    }}
                  >

                    <Button
                      onClick={handleClose}
                      sx={{
                        borderRadius: "8px",
                        paddingY: "8px",
                        paddingX: "12px",
                        mt: "2.5em",
                        fontSize: "14px",
                        fontWeight: "600",
                        textTransform: "none",
                        "&.Mui-disabled": {
                          opacity: "0.3",
                          backgroundColor: "primary.main",
                          color: "white",
                        },
                      }}
                      variant="outlined"
                      color="primary"
                      disableElevation
                      disableFocusRipple
                      disableRipple
                      startIcon={<ArrowBackIcon />}
                    >
                      Back
                    </Button>

                    <Button
                      onClick={() => {
                        continueReg()
                      }}
                      sx={{
                        borderRadius: "8px",
                        paddingY: "8px",
                        paddingX: "12px",
                        mt: "2.5em",
                        fontSize: "14px",
                        fontWeight: "600",
                        textTransform: "none",
                        "&.Mui-disabled": {
                          opacity: "0.3",
                          backgroundColor: "primary.main",
                          color: "white",
                        },
                      }}
                      variant="contained"
                      color="primary"
                      disableElevation
                      disableFocusRipple
                      disableRipple
                    >
                      Continue
                    </Button>

                  </Box>
                </Box> : <Box
                  sx={{
                    paddingX: {
                      xs: "2.5em",
                      sm: "4em",
                      md: "4em",
                    },
                  }}
                  bgcolor={"white"}
                  maxWidth={"30rem"}
                  width={"90%"}
                  paddingY="2em"
                  borderRadius={"16px"}
                  mt='2em'
                >
                  <Alert
                    severity="error"
                    color={"grey"}
                    sx={{ marginBlock: "1em", borderRadius: "8px", fontSize: "14px", background: '#fafafa', color: '#425A70' }}
                  >
                    Listed below are the required documents, and necessary informarion required to complete the registration and onboarding process on the platform
                  </Alert>
                  <Box
                    alignItems={"flex-start"}
                    display="flex"
                    columnGap={"10px"}
                    mb="1em"
                  >
                    <Box
                      bgcolor={"success.light"}
                      borderRadius="4px"
                      justifyContent={"center"}
                      alignItems={"center"}
                      display="flex"
                      color={"success.dark"}
                      flexGrow={0}
                    >
                      <Typography
                        variant="small"
                        color={"success.dark"}
                        px="0.6em"
                        fontWeight={600}
                      >
                        1
                      </Typography>
                    </Box>
                    <Typography variant="big" component={"span"}>
                      Choose a primary account holder (Super user), who will manage the Individual’s iDonatio account. If the
                      account is a joint account, you must decide who will be the primary account holder, the other person can be
                      added once registration and onboarding are complete.
                    </Typography>
                  </Box>
                  <Box
                    alignItems={"flex-start"}
                    display="flex"
                    columnGap={"10px"}
                    mb="1em"
                  >
                    <Box
                      bgcolor={"success.light"}
                      borderRadius="4px"
                      justifyContent={"center"}
                      alignItems={"center"}
                      display="flex"
                      color={"success.dark"}
                      flexGrow={0}
                    >
                      <Typography
                        variant="small"
                        color={"success.dark"}
                        px="0.6em"
                        fontWeight={600}
                      >
                        2
                      </Typography>
                    </Box>
                    <Typography variant="big" component={"span"}>
                      The primary account holder should complete the registration and the confirmation process outlined below.
                    </Typography>
                  </Box>
                  <Box
                    alignItems={"flex-start"}
                    display="flex"
                    columnGap={"10px"}
                    mb="1em"
                  >
                    <Box
                      bgcolor={"success.light"}
                      borderRadius="4px"
                      justifyContent={"center"}
                      alignItems={"center"}
                      display="flex"
                      color={"success.dark"}
                      flexGrow={0}
                    >
                      <Typography
                        variant="small"
                        color={"success.dark"}
                        px="0.6em"
                        fontWeight={600}
                      >
                        3
                      </Typography>
                    </Box>
                    <Typography variant="big" component={"span"}>
                      Once the account is set up, additional users who may each have different levels of access depending on
                      their role may be added. If it is a joint ownership account, the other super user can be added.
                    </Typography>
                  </Box>
                  <Box
                    alignItems={"flex-start"}
                    display="flex"
                    columnGap={"10px"}
                    mb="1em"
                  >
                    <Box
                      bgcolor={"success.light"}
                      borderRadius="4px"
                      justifyContent={"center"}
                      alignItems={"center"}
                      display="flex"
                      color={"success.dark"}
                      flexGrow={0}
                    >
                      <Typography
                        variant="small"
                        color={"success.dark"}
                        px="0.6em"
                        fontWeight={600}
                      >
                        4
                      </Typography>
                    </Box>
                    <Typography variant="big" component={"span"}>
                      You will need the following to complete your registration
                      and confirmation process:
                    </Typography>
                  </Box>
                  <LinedBox>
                    <Box
                      alignItems={"flex-start"}
                      display="flex"
                      columnGap={"10px"}
                      mb="1em"
                    >
                      <Box
                        bgcolor={"primary.light"}
                        borderRadius="4px"
                        justifyContent={"center"}
                        alignItems={"center"}
                        display="flex"
                        color={"success.dark"}
                        flexGrow={0}
                      >
                        <CheckIcon fontSize="14px" />
                      </Box>
                      <Typography variant="big" component={"span"}>
                        Individual account details: <br /> i. Name for the account. This is what will be displayed to Donors. <br /> ii. Contact address, this is the super user address. <br /> iii. Contact telephone number, this is the super user phone number. <br /> iv. Contact email address (for communication). <br /> v. Website URL or social media handle for the individual account.
                      </Typography>
                    </Box>
                    <Box
                      alignItems={"flex-start"}
                      display="flex"
                      columnGap={"10px"}
                      mb="1em"
                    >
                      <Box
                        bgcolor={"primary.light"}
                        borderRadius="4px"
                        justifyContent={"center"}
                        alignItems={"center"}
                        display="flex"
                        color={"success.dark"}
                        flexGrow={0}
                      >
                        <CheckIcon fontSize="14px" />
                      </Box>
                      <Typography variant="big" component={"span"}>
                        Individual account’s bank account <br />
                        i. Account number <br /> ii. Sort code
                      </Typography>
                    </Box>
                    <Box
                      alignItems={"flex-start"}
                      display="flex"
                      columnGap={"10px"}
                      mb="1em"
                    >
                      <Box
                        bgcolor={"primary.light"}
                        borderRadius="4px"
                        justifyContent={"center"}
                        alignItems={"center"}
                        display="flex"
                        color={"success.dark"}
                        flexGrow={0}
                      >
                        <CheckIcon fontSize="14px" />
                      </Box>
                      <Typography variant="big" component={"span"}>
                        Primary account holder’s details <br />
                        i. Name
                        of primary account holder <br /> ii. Email address (Used as their
                        primary login.) <br />iii. Date of birth  <br />  iv. Home address <br /> <span style={{ color: 'red' }}> v. Two verification documents: proof of identity and address</span>
                      </Typography>
                    </Box>
                    <Box
                      alignItems={"flex-start"}
                      display="flex"
                      columnGap={"10px"}
                      mb="1em"
                    >
                      <Box
                        bgcolor={"primary.light"}
                        borderRadius="4px"
                        justifyContent={"center"}
                        alignItems={"center"}
                        display="flex"
                        color={"success.dark"}
                        flexGrow={0}
                      >
                        <CheckIcon fontSize="14px" />
                      </Box>
                      <Typography variant="big" component={"span"}>
                        Proof of Individual account registration and identity  <br />
                        i. Photocopy of primary account holder’s passport <br /> ii. Proof of address of primary account holder (driver’s license, utility bill or bank statement.
                        Not mobile or telephone bill) <br /> iii. Passport photograph.
                      </Typography>
                    </Box>
                  </LinedBox>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent:
                        "space-between"
                    }}
                  >

                    <Button
                      onClick={handleClose}
                      sx={{
                        borderRadius: "8px",
                        paddingY: "8px",
                        paddingX: "12px",
                        mt: "2.5em",
                        fontSize: "14px",
                        fontWeight: "600",
                        textTransform: "none",
                        "&.Mui-disabled": {
                          opacity: "0.3",
                          backgroundColor: "primary.main",
                          color: "white",
                        },
                      }}
                      variant="outlined"
                      color="primary"
                      disableElevation
                      disableFocusRipple
                      disableRipple
                      startIcon={<ArrowBackIcon />}
                    >
                      Back
                    </Button>

                    <Button
                      onClick={() => {
                        // router.push('/register')
                        // handleClose()
                        handleShowChange()
                      }}
                      sx={{
                        borderRadius: "8px",
                        paddingY: "8px",
                        paddingX: "12px",
                        mt: "2.5em",
                        fontSize: "14px",
                        fontWeight: "600",
                        textTransform: "none",
                        "&.Mui-disabled": {
                          opacity: "0.3",
                          backgroundColor: "primary.main",
                          color: "white",
                        },
                      }}
                      variant="contained"
                      color="primary"
                      disableElevation
                      disableFocusRipple
                      disableRipple
                    >
                      Continue
                    </Button>

                  </Box>
                </Box>
              }
            </Container>
          </Box>
        </DialogContent>
      </Dialog>

      {showAlert && (
        <AlertDialog
          // value={value}
          openDialog={showAlert}
          closeDialog={() => setShowAlert(false)}
        />
      )}
    </>
  );
};

export default RegisterModal;
